
export type IIMAGE_SPEC = keyof typeof IMAGE_SPEC
export const IMAGE_SPEC = {
  RECO_FULL : {
    name : 'Full Image',
    fieldId : 'fullImage',
    minWidth : 321,
    minHeight : 214
  },
  RECO_SHORT : {
    name : 'Short Image',
    fieldId : 'shortenedImage',
    minWidth : 285,
    minHeight : 340
  },
  RECO_LONG : {
    name : 'Long Image',
    fieldId : 'elongatedImage',
    minWidth : 800,
    minHeight : 345
  },
  RECO_HER : {
    name : 'HER Image',
    fieldId : 'herImage',
    minWidth : 425,
    minHeight : 550
  },
  ICON : {
    name : 'Icon',
    fieldId : 'icon',
    minWidth : 100,
    minHeight : 100
  }
}
